module.exports = __webpack_public_path__ + "img/danye1.68206cee.jpg";